import { useCallback } from 'react';
import { ClbInputSearch } from '@celebration/design-system/dist/lib/input-search';
import { useTranslation } from 'react-i18next';
import { Icons } from '@celebration/design-system/dist/lib/icon/props.types';
import TableToolbar, {
    TableToolbarSlots,
} from '../table/components/table.toolbar';
import ButtonIcon from '../button-icon';
import Button from '../button';
import ButtonGroup from '../button-group';
import InputSearch from '../input-search';
import { TableContainerSlots } from '../table/components/table.container';
import IToolbarTableData from './interfaces/IToolbarTableData';

function ToolbarTableComponent({
    toolbarIconsActions,
    toolbarButtonList,
    toolbarSearchCallback,
    setSearchTerm,
    searchTerm,
}: Readonly<IToolbarTableData>) {
    const { t } = useTranslation();
    const getInputValue = useCallback((event: Event) => {
        return (event.target as ClbInputSearch).value;
    }, []);

    return (
        <TableToolbar
            slot={TableContainerSlots.toolbar}
            data-testid="table-toolbar"
        >
            {!!toolbarIconsActions?.length &&
                toolbarIconsActions.map(item => {
                    return (
                        <ButtonIcon
                            key={`toolbarIcon@${item.icon}`}
                            icon={item.icon as Icons}
                            tooltipLabel={item.tooltipLabel}
                            tooltipPosition="left"
                            onClbClick={item.callback}
                            slot={TableToolbarSlots.buttons}
                            data-testid="toolbar-icon-actions"
                            disabled={item.disabled}
                        />
                    );
                })}

            {toolbarButtonList && toolbarButtonList.length === 1 && (
                <Button
                    slot={TableToolbarSlots.buttons}
                    onClbClick={toolbarButtonList[0].callback}
                    data-testid="toolbar-action-button"
                >
                    {toolbarButtonList[0].label}
                </Button>
            )}

            {toolbarButtonList && toolbarButtonList.length > 1 && (
                <ButtonGroup
                    slot={TableToolbarSlots.buttons}
                    buttonsList={toolbarButtonList}
                    data-testid="toolbar-action-button-group"
                />
            )}

            {toolbarSearchCallback && (
                <InputSearch
                    slot={TableToolbarSlots.search}
                    placeholder={t('Pesquisar')}
                    value={searchTerm ?? ''}
                    onClbSearchChange={e => setSearchTerm(getInputValue(e))}
                    data-testid="table-search-input"
                />
            )}
        </TableToolbar>
    );
}

export default ToolbarTableComponent;
